import { createAsyncThunk } from "@reduxjs/toolkit";
import { type RejectParams } from "../../../domain/entities/undelivered";
import { type UndeliveredDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const reject = createAsyncThunk<
  void,
  RejectParams,
  { dispatch: UndeliveredDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.REJECT, async (params, { extra }) => {
  await extra.undeliveredRepo.reject(params);
});
